import { View } from 'components/View'
import ExerciseMediaImage from 'containers/ExerciseMediaImage'
import { Image } from 'components/Image'
import RestImage from 'components/RestImage/index.js'
import React from 'react'

export default function SetRowImage ({ exerciseId, isRest }) {
  const defaultImageStyle = {
    borderTopLeftRadius: '6px',
    borderBottomLeftRadius: '6px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }

  const width = '80px'
  const imageStyle = {
    ...defaultImageStyle,
    height: '100px',
    minWidth: width,
    width,
    objectFit: 'cover'
  }

  if (isRest) {
    return <RestImage style={imageStyle} />
  }

  return (
    <View style={imageStyle}>
      <ExerciseMediaImage
        id={exerciseId}
        alt='exercise-img'
        aspectRatio={Image.ASPECT_RATIO.TALL}
        style={defaultImageStyle}
      />
    </View>
  )
}
